import React from 'react';
import { Popconfirm } from 'antd';
import { FormattedMessage } from 'react-intl';

interface IProps {
  triggerType: 'back-click' | 'cancel-click';
  placement: 'top' | 'right' | 'bottom' | 'left' | 'bottomRight' | 'topRight' | 'topLeft';
  onConfirm: () => void;
  onCancel?: () => void;
}

const OrderCancelConfirm: React.SFC<IProps> = ({
  triggerType,
  placement,
  onConfirm,
  onCancel,
  children,
}) => {

  if (!triggerType) {
    return null;
  }

  const title = (
    <FormattedMessage 
      defaultMessage={
        triggerType === 'cancel-click' ?
        'Är du säker på att du vill avbryta reservationen?' :
        'Tillbaka-klick i detta läget innebär att reservationen avbryts.'
      }
      id={
        triggerType === 'cancel-click' ?
        'order.cancel.confirm' :
        'order.cancel.backclick.confirm'
      }
    />
  );

  const confirmButton = (
    <FormattedMessage 
      defaultMessage='Avbryt reservationen'
      id='order.cancel.YES'
    />
  );

  const cancelButton = (
    <FormattedMessage 
      defaultMessage='Stanna kvar'
      id='order.cancel.NO'
    />
  );

  return (
    <Popconfirm 
      title={ title } 
      okText={ confirmButton } 
      cancelText={ cancelButton }
      onCancel={ onCancel }
      onConfirm={ onConfirm }
      placement={ placement }
    >
      { children }
    </Popconfirm>
  );
};

export default OrderCancelConfirm;


// WEBPACK FOOTER //
// ./src/components/OrderCancelConfirm/OrderCancelConfirm.tsx